export function BrandPanel() {
  const features = ['🎫 RFID', '🍕 POS', '📊 تقارير', '🔒 صلاحيات', '🖨️ طباعة 80mm'];

  return (
    <div
      className="relative overflow-hidden flex flex-col justify-between p-10 lg:p-12 text-white min-h-[280px] lg:min-h-screen"
      style={{
        background:
          'linear-gradient(135deg, #FF7A1A 0%, #FFB627 60%, #EC4899 110%)'
      }}
    >
      <div className="flex items-center gap-4 relative z-10">
        <img
          src="/kidzo-mark.png"
          alt="Kids Zone"
          className="w-16 h-16 shrink-0 object-contain"
          style={{ filter: 'drop-shadow(0 6px 18px rgba(0,0,0,.25))' }}
        />
        <div>
          <div className="font-extrabold text-[22px]">Kids Zone</div>
          <div className="opacity-85 text-[13px]">Kids Zone Management Platform</div>
        </div>
      </div>

      <div className="relative z-10">
        <h1 className="text-3xl lg:text-[42px] font-extrabold leading-tight m-0 tracking-tight">
          أهلاً بك،
          <br />
          إدارة قاعة الألعاب
          <br />
          أصبحت أسهل.
        </h1>
        <p className="text-base opacity-90 mt-4 max-w-[440px] leading-relaxed">
          نظام متكامل لاستقبال الأطفال، نقاط البيع، البوابات الذكية، المخزون، والتقارير المالية اليومية.
        </p>
        <div className="flex gap-2.5 mt-6 flex-wrap">
          {features.map((t) => (
            <span
              key={t}
              className="px-3 py-1.5 rounded-full text-xs font-semibold"
              style={{ background: 'rgba(255,255,255,.18)', backdropFilter: 'blur(8px)' }}
            >
              {t}
            </span>
          ))}
        </div>
      </div>

      <div className="text-xs opacity-80 relative z-10">الإصدار 2.4.1 • © 2026 Kids Zone</div>

      <div
        className="absolute -top-10 -left-10 w-[200px] h-[200px] rounded-full"
        style={{ background: 'rgba(255,255,255,.08)' }}
      />
      <div
        className="absolute bottom-20 left-16 w-[120px] h-[120px] rounded-full"
        style={{ background: 'rgba(255,255,255,.06)' }}
      />
      <div className="absolute top-[40%] -left-8 text-[72px] opacity-20 pointer-events-none">🎠</div>
      <div className="absolute bottom-[15%] left-[45%] text-[54px] opacity-15 pointer-events-none">🎪</div>
    </div>
  );
}
